import {
  GET_SCREEN_REQUEST,
  GET_SCREEN_SUCCESS,
  GET_SCREEN_FAILURE,
  GET_KYC_PAGE_LIST,
  UPDATE_SCREEN_PAGE,
  UPDATE_DIGILOCKER,
  SET_ADDRESS_FORCEFULLY,
  SET_FORECEFULLY_STATE,
  SET_PD_FORCEFULLY,
  KYC_STATUS_SUCCESS,
  UPDATE_NAVIGATION_KYC_STATUS,
} from "./navigationTypes";
const initialState = {
  loading: false,
  navigationPage: "start",
  pageIndex: null,
  pageFlow: [],
  kycStatus: [],
  pageName: "default",
  digilocker: false,
  setforcefully: false,
  panState: false,
  redirect_esign: null,
  nsdl_redirect_url_generated: null,
  nsdl_redirect_url_generated_2: null,
  esign_generated: 0,
  esign_generated_2: 0,
  kra_esign: 0,
  kyc_esign: 0,
  stagesData: null,
  isKycStatusCompleted: false,
  kycPageName: {}
};
//Accepted Values
// ["PAN","Address","PersonalData","BankVerification","SingnatureUpload","VisualVerification","IncomeProof","Review","BrokerPayment","ESignature"]
const navigationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_FORECEFULLY_STATE:
      return {
        ...state,
        setforcefully: payload,
      };
    case SET_ADDRESS_FORCEFULLY:
      return {
        ...state,
        navigationPage: payload.pageName,
        pageIndex: payload.index,
        setforcefully: payload.forcefully,
      };
    case SET_PD_FORCEFULLY:
      return {
        ...state,
        navigationPage: "PersonalData",
        pageIndex: payload,
        setforcefully: false,
      };
    case GET_SCREEN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_DIGILOCKER:
      return {
        ...state,
        digilocker: payload,
      };
    case GET_SCREEN_SUCCESS:
      return {
        ...state,
        loading: false,
        pageFlow: payload?.flow,
        kycStatus: payload?.kyc_status,
        navigationPage:
          state.pageIndex == null ? payload?.flow?.[0] : state.navigationPage,
        pageIndex: state.navigationPage == "start" ? 0 : state.pageIndex,
        pageName: action.pageName,
        panState: payload.panState,
        redirect_esign: payload.redirect_esign,
        nsdl_redirect_url_generated: payload.nsdl_redirect_url_generated,
        nsdl_redirect_url_generated_2: payload.nsdl_redirect_url_generated_2,
        esign_generated: payload.esign_generated,
        esign_generated_2: payload.esign_generated_2,
        kyc_esign: payload.kyc_esign,
        kra_esign: payload.kra_esign,
        stagesData: payload
      };
    case UPDATE_NAVIGATION_KYC_STATUS:
      const { pageName, status } = payload;
      return {
        ...state,
        kycStatus: state.kycStatus.map((page) => {
          if (page[pageName]) {
            return {
              [pageName]: {
                ...page[pageName],
                status: status
              }
            };
          }
          return page;
        })
      };
    case GET_SCREEN_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case GET_KYC_PAGE_LIST:{
      return {
        ...state,
        kycPageName: payload,
      };
    }
    case UPDATE_SCREEN_PAGE:
      return {
        ...state,
        navigationPage:
          state.pageIndex == null
            ? state.pageFlow[parseInt(state?.pageIndex) + 0]
            : state.pageFlow[parseInt(state?.pageIndex) + 1],
        pageIndex: state.pageIndex == null ? 0 : parseInt(state?.pageIndex) + 1,
      };
    case KYC_STATUS_SUCCESS:
      return {
        ...state,
        isKycStatusCompleted: payload,
      };
    default:
      return state;
  }
};

export default navigationReducer;
